export default "__VITE_ASSET__CRPhD6B8__"